import { LocalDateTime } from 'js-joda';
import { PureComponent } from 'react';

import { CurrencyContext, core } from '@tock/coretypes';
import { DisplayDateTime } from '@tock/time';
import { DisplayMoney } from '@tock/money';
import { Typography } from 'omakase';
import { pluralize } from '@tock/shared/utils/pluralize';

interface Props {
  purchase: core.PastPurchase;
  transferToEmail: string;
  transferPrice: number;
}

/**
 * The receipt used for transfer flow.
 */
export default class Receipt extends PureComponent<Props> {
  render() {
    const { transferToEmail, transferPrice, purchase } = this.props;

    const partySize = purchase.ticketCount;

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const business = purchase.business!;

    return (
      <div className="Receipt">
        <div className="Receipt-section">
          <div className="Receipt-line">
            <div className="Receipt-lineDescription">
              <Typography color="inherit" component="span" variant="body02">
                Transferring to {transferToEmail} for:
              </Typography>
            </div>

            <div className="Receipt-lineTotal">
              <Typography color="inherit" component="span" variant="body02">
                <CurrencyContext.Provider
                  value={
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    business.currencyCode!
                  }
                >
                  <DisplayMoney amount={transferPrice} />
                </CurrencyContext.Provider>
              </Typography>
            </div>
          </div>
        </div>

        <div className="Receipt-section">
          <div className="Receipt-detail">
            <Typography color="inherit" component="span" variant="body02">
              {pluralize(partySize, 'guest')} on&nbsp;
              <DisplayDateTime
                dateTimeValue={LocalDateTime.parse(purchase.ticketDateTime)}
                displayMonthAs="long"
                showWeekday={true}
              />
            </Typography>
          </div>

          <div className="Receipt-detail">
            <Typography color="inherit" component="span" variant="body02">
              {purchase.ticketTypeName} at {business.name}
            </Typography>
          </div>
          <div className="Receiept-detail">
            {purchase.seatingAreaName && (
              <Typography color="inherit" component="span" variant="body02">
                {purchase.seatingAreaName} Seating
              </Typography>
            )}
          </div>
        </div>
      </div>
    );
  }
}
